<template>
    <div>
        <DxDataGrid
            :key="id"
            keyExpr="id"
            :data-source="listStore"
            :columns="gridColumns"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :show-borders="true"
            :remote-operations="true"
            :focused-row-enabled="true"
            @contentReady="contentReadyFunc"
            @context-menu-preparing="onContextMenu"
            @focusedRowChanging="onFocusedRowChangingFunc"
            @onContextMenu="onContextMenu"
        >
            <DxSelection mode="multiple" :allowSelectAll="false" />

            <DxLoadPanel :visible="visible" :show-indicator="visible" :show-pane="visible" />
        </DxDataGrid>
    </div>
</template>

<script>
export default {
    name: 'temp_view-kv-customer-vers-children',
};
</script>

<script setup>
import { onMounted, ref, toRefs } from 'vue';

import { DxDataGrid } from 'devextreme-vue';
import { DxSelection } from 'devextreme-vue/data-grid';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
// import { getKvCustomerVersChildList } from '../../service/counteragent-service';

const props = defineProps({
    id: {
        type: Number,
        default: -1,
    },
    props: {
        type: Object,
        default: () => {},
    },
    data: {
        type: Object,
        default: () => {},
    },
});

const { columnsMeta, onFocusedRowChanging, onContextMenu, selectedParents } = toRefs(props.props);

// const listStore = getKvCustomerVersChildList(props.id);
const cellTemplates = [];
const editCellTemplates = [];
const gridColumns = ref([]);
const visible = ref(true);
const filterOperations = {
    string: ['contains', 'notcontains', 'startswith', 'endswith', '=', '<>'],
    numeric: ['=', '<>', '<', '>', '<=', '>='],
    date: ['=', 'between'],
};

onMounted(() => {
    gridColumns.value = processColumns(columnsMeta.value, null);
});

const contentReadyFunc = e => {
    if (selectedParents.value.includes(props.id)) {
        e.component.selectAll();
    }
};
const onFocusedRowChangingFunc = e => {
    onFocusedRowChanging.value(e);
};

// listStore.on('loading', () => {
//     visible.value = true;
// });

// listStore.on('loaded', () => {
//     visible.value = false;
// });

const processColumns = (columns, parentId) => {
    return columns
        .filter(column => column.parent_id === parentId)
        .sort((a, b) => a.index - b.index)
        .map(column => {
            const childColumns = processColumns(columns, column.id);
            if (childColumns.length > 0) {
                const obj = {
                    caption: column.text,
                    columns: childColumns,
                };
                if (column.cssClass) obj.cssClass = column.cssClass;
                return obj;
            } else {
                const obj = {
                    caption: column.text,
                    visible: column.visible !== false,
                };
                obj.dataField = column.field ? column.field : '';
                obj.dataType = column.data_type ? column.data_type : '';
                obj.filterOperations = column.data_type ? filterOperations[column.data_type] : '';
                obj.width = column.width ? column.width : 100;
                if (column.format) obj.format = column.format;
                if (column.cellTemplate) {
                    const name = `cellTemplate-${column.field}`;
                    const template = { name, component: column.cellTemplate };
                    cellTemplates.push(template);
                    obj.cellTemplate = name;
                }
                if (column.editCellTemplate) {
                    const name = `editCellTemplate-${column.field}`;
                    const template = { name, component: column.editCellTemplate };
                    editCellTemplates.push(template);
                    obj.editCellTemplate = name;
                }
                if (column.editorOptions) obj.editorOptions = column.editorOptions;
                if (column.sortingMethod) obj.sortingMethod = column.sortingMethod;
                if (column.alignment) obj.alignment = column.alignment;
                if (column.fixed) obj.fixed = column.fixed;
                if (column.cssClass) obj.cssClass = column.cssClass;
                return obj;
            }
        });
};
</script>
